import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { WHATSAPP } from "../../data/site";
import { WORKFLOX } from "../../data/workflox";
import { SOCIALS, Mask, WorkfloxLink } from "./Chrome";

function Contact() {
  return (
    <section id="contact" className="section contact">
      <div className="wrap">
        <p className="eyebrow">Contact</p>
        <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" className="contact-cta" data-cursor="grow">
          <Mask>Let&rsquo;s build</Mask>
          <Mask>
            <em>your product</em>
          </Mask>
        </a>

        <div className="contact-grid">
          <div data-reveal>
            <h4>Connect</h4>
            <div className="contact-links">
              {SOCIALS.map(({ href, label, icon }) => (
                <a key={label} href={href} target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={icon} /> {label}
                </a>
              ))}
            </div>
          </div>
          <div data-reveal>
            <h4>Availability</h4>
            <p>
              Taking on new clients in the UAE, Saudi Arabia, Qatar and Pakistan. Lahore is one hour ahead of Dubai
              and two ahead of Riyadh — same-day replies, every working day.
            </p>
          </div>
          <div data-reveal>
            <h4>Based in</h4>
            <p>
              Lahore, Pakistan (GMT+5)
              <br />
              Working remotely with founders across the Gulf, Europe and the USA.
            </p>
          </div>
        </div>

        <footer className="footer">
          <p>© {new Date().getFullYear()} Sami · Fractional CTO &amp; AI Product Builder</p>
          <p>
            <WorkfloxLink href={WORKFLOX}>workflox.net</WorkfloxLink> ·{" "}
            <WorkfloxLink href={`${WORKFLOX}/blog`}>Blog</WorkfloxLink> · Layout inspired by{" "}
            <a href="https://github.com/MoncyDev/Portfolio-Website" target="_blank" rel="noopener noreferrer">
              Moncy Yohannan
            </a>
          </p>
        </footer>
      </div>
    </section>
  );
}

export default Contact;
